import { useEffect, useMemo, useRef, useState } from 'react';
export const useFieldAlignEvent = 'useFieldAlignEvent';
export const useFieldAlign = opt => {
  const {
    disableAlign,
    domSelector,
    calDeps,
    maxWidth: maxWidthIn = 96
  } = opt;
  const [width, setWidth] = useState(null);
  const fieldRef = useRef(null);
  useEffect(() => {
    if (disableAlign) {
      return;
    }

    const listener = e => {
      var _fieldRef$current;

      const {
        maxWidth,
        alignLeft
      } = e.detail;
      const left = (_fieldRef$current = fieldRef.current) === null || _fieldRef$current === void 0 ? void 0 : _fieldRef$current.getBoundingClientRect().left;

      if (alignLeft !== left) {
        return;
      }

      setWidth(maxWidth);
    }; // @ts-expect-error


    window.addEventListener(useFieldAlignEvent, listener);
    return () => {
      // @ts-expect-error
      window.removeEventListener(useFieldAlignEvent, listener);
    };
  }, [disableAlign]);
  useEffect(() => {
    if (disableAlign) {
      return;
    }

    const dom = document.querySelectorAll(domSelector);
    const fieldDom = fieldRef.current;
    const fieldDomLeft = fieldDom.getBoundingClientRect().left;
    let maxWidth = 0; // eslint-disable-next-line @typescript-eslint/prefer-for-of

    for (let i = 0; i < dom.length; i++) {
      const rect = dom[i].getBoundingClientRect(); // 判断是否在同一列

      if (rect.left !== fieldDomLeft) {
        continue;
      }

      if (rect.width > maxWidth) {
        // 8个字加全角冒号（：）时，要-1px，才能保证是7个字换行，不然会多放一个字进去，96是算了冒号的
        const calc7Chars = dom[i].innerText.replace('：', '').length > 7 ? maxWidthIn - 1 : maxWidthIn;
        maxWidth = rect.width > maxWidthIn ? calc7Chars : rect.width;
      }
    }

    if (!maxWidth) {
      return;
    }

    window.dispatchEvent(new CustomEvent(useFieldAlignEvent, {
      detail: {
        maxWidth: maxWidth,
        alignLeft: fieldDomLeft
      }
    }));
  }, calDeps !== null && calDeps !== void 0 ? calDeps : []);
  const fieldStyle = useMemo(() => {
    if (disableAlign) {
      return {};
    }

    if (width == null) {
      return {};
    }

    return {
      width
    };
  }, [disableAlign, width]);
  return {
    fieldStyle,
    fieldRef
  };
};
//# sourceMappingURL=es/useFieldAlign.js.map